import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../../redux/features/cartSlice";
import { toast } from "react-toastify";
import { removeFromWishlist } from "../../redux/features/wishlistSlice";
import { getPercentage } from "../../resources/helper/helper";
import { useNavigate } from "react-router-dom";

export default function Wishlist() {
  const { wishlist } = useSelector((state) => state.wishlist);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleCart = (product) => {
    dispatch(addToCart({ ...product, quantity: 1 }));
    toast.success("Added successfully!", {
      position: "top-center",
      theme: "colored",
    });
  };
  const handleRemoveFromWishlist = (id) => {
    dispatch(removeFromWishlist(id));
  };

  const handleDetailsNavigation = (item) => {
    navigate("/productDetails", { state: item });
  };
  return (
    <div>
      <main className="main">
        <div className="page-header breadcrumb-wrap">
          <div className="container">
            <div className="breadcrumb">
              <a rel="nofollow">
                <i className="fi-rs-home mr-5" />
                Home
              </a>
              <span /> Shop <span /> Fillter
            </div>
          </div>
        </div>
        <div className="container mb-30 mt-50">
          <div className="row">
            <div className="col-xl-10 col-lg-12 m-auto">
              <div className="mb-50">
                <h1 className="heading-2 mb-10">Your Wishlist</h1>
                {wishlist && wishlist?.length > 0 ? (
                  <h6 className="text-body">
                    There are{" "}
                    <span className="text-brand">{wishlist?.length}</span>{" "}
                    products in this list
                  </h6>
                ) : (
                  <h6 className="text-body">Your Wishlist is empty</h6>
                )}
              </div>
              <div className="table-responsive shopping-summery">
                <table className="table table-wishlist">
                  <thead>
                    <tr className="main-heading">
                      <th className="custome-checkbox start pl-30"></th>
                      <th scope="col" colSpan={2}>
                        Product
                      </th>
                      <th scope="col">Price</th>
                      <th scope="col">Stock Status</th>
                      <th scope="col">Action</th>
                      <th scope="col" className="end">
                        Remove
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {wishlist && wishlist?.length > 0 ? (
                      wishlist.map((item) => (
                        <tr className="pt-30">
                          <td className="custome-checkbox pl-30"></td>
                          <td className="image product-thumbnail pt-40">
                            <img src={item?.featured_media} alt="#" />
                          </td>
                          <td className="product-des product-name">
                            <h6 onClick={() => handleDetailsNavigation(item)}>
                              <a className="product-name mb-10">{item?.name}</a>
                            </h6>
                            <div className="product-rate-cover">
                              <div className="product-rate d-inline-block">
                                <div
                                  className="product-rating"
                                  style={{
                                    width: `${getPercentage(
                                      item?.ratings?.averageRating
                                    )}%`,
                                  }}
                                />
                              </div>
                              <span className="font-small ml-5 text-muted">
                                {item?.ratings?.averageRating
                                  ? item?.ratings?.averageRating
                                  : 0}
                              </span>
                            </div>
                          </td>
                          <td className="price" data-title="Price">
                            <h3 className="text-brand">Rs.2.51</h3>
                          </td>
                          <td
                            className="text-center detail-info"
                            data-title="Stock"
                          >
                            <span
                              className={`stock-status ${
                                item?.stock > 0 ? "in-stock" : "out-stock"
                              } mb-0`}
                            >
                              {" "}
                              {item?.stock > 0 ? "In Stock" : "Out of Stock"}
                            </span>
                          </td>
                          <td className="text-right" data-title="Cart">
                            <button
                              className="btn btn-sm"
                              onClick={() => handleCart(item)}
                            >
                              Add to cart
                            </button>
                          </td>
                          <td
                            className="action text-center"
                            data-title="Remove"
                          >
                            <a
                              onClick={() =>
                                handleRemoveFromWishlist(item?._id)
                              }
                              className="text-body"
                            >
                              <i className="fi-rs-trash" />
                            </a>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <></>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
}
